import React from 'react';
import './BusinessModel.css';

const BusinessModel = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const steps = [
    {
      number: 1,
      title: 'نطور اللعبة',
      description: 'نصمم ألعاباً اجتماعية تفاعلية عالية الجودة تجذب آلاف اللاعبين'
    },
    {
      number: 2,
      title: 'الشراكة مع العلامات',
      description: 'نتعاون مع العلامات التجارية لدمج منتجاتهم بشكل طبيعي في اللعبة'
    },
    {
      number: 3,
      title: 'الجميع يربح',
      description: 'العلامات تصل لجمهورها، اللاعبون يستمتعون، ونحن ننمو معاً'
    }
  ];

  return (
    <section id="partners" className="partners">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">نموذج العمل</h2>
          <p className="section-subtitle">شراكات مربحة للجميع</p>
        </div>

        <div className="business-model">
          {steps.map((step, index) => (
            <React.Fragment key={step.number}>
              <div className="model-card">
                <div className="model-number">{step.number}</div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
              {index < steps.length - 1 && <div className="model-arrow">←</div>}
            </React.Fragment>
          ))}
        </div>

        <div className="cta-section">
          <h3>هل أنت علامة تجارية تبحث عن طريقة مبتكرة للوصول لجمهورك؟</h3>
          <button onClick={scrollToContact} className="btn btn-primary btn-large">لنبدأ الحديث</button>
        </div>
      </div>
    </section>
  );
};

export default BusinessModel;
